'use client';

import React, { useState, useEffect } from 'react';
import { Locale } from '@/i18n-config';
import Carousel from '../carousel/carousel';

type Props = {
    lang: Locale
}


const Hero = (props: Props) => {
    const { lang } = props;
    const [dictionary, setDictionary] = useState<any>(null);
    const [carousel, setCarousel] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Default carousel data for loading state
    const defaultCarousel = {
        id: 'default',
        slug: 'default',
        type: 'main',
        items: [{
            id: 'default-slide',
            imageUrl: '/files/images/carosel/sunset-harvesting-a-tractor-and-combine-in-action-328692.jpg',
            sortOrder: 1,
            isActive: true,
            isMobileOnly: false,
            translations: [{
                id: 'default-translation',
                lang: lang,
                header: 'Paying agency supports Ukrainian farmers',
                subheader: 'This is real financing that works quickly and transparently.',
                buttonText1: 'Get Started',
                buttonLink1: '#',
                // Add all optional fields as undefined
                caption: undefined,
                link: undefined,
                fullDescription: undefined,
                buttonText2: undefined,
                buttonLink2: undefined
            }]
        }]
    };

    // Default dictionary for loading state
    const defaultDictionary = {
        loading: 'Loading...',
        welcome: 'Welcome'
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch dictionary from API
                const dictResponse = await fetch(`/api/dictionary?lang=${lang}`);
                if (dictResponse.ok) {
                    const dict = await dictResponse.json();
                    setDictionary(dict);
                } else {
                    console.error('Failed to fetch dictionary');
                    setError('Failed to load dictionary');
                    setLoading(false);
                    return;
                }

                // Fetch carousel data
                const carouselResponse = await fetch(`/api/carousel/main?lang=${lang}`);
                if (carouselResponse.ok) {
                    const carouselData = await carouselResponse.json();                    
                    setCarousel(carouselData);
                } else if (carouselResponse.status === 404) {
                    setError('Carousel not found');
                } else {
                    setError('Failed to load carousel');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Failed to load content');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [lang]);

    if (loading) {
        return (
            <Carousel
                carousel={defaultCarousel}
                dictionary={defaultDictionary}
                lang={lang}
            />
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center h-[70vh] bg-gray-100 dark:bg-gray-800">
                <div className="text-center">
                    <p className="text-red-600 dark:text-red-400 mb-4">{error}</p>
                    <p className="text-gray-600 dark:text-gray-400">Please try refreshing the page</p>
                </div>
            </div>
        );
    }

    if (!carousel || !dictionary) {
        return (
            <div className="flex items-center justify-center h-[70vh] bg-gray-100 dark:bg-gray-800">
                <p className="text-gray-600 dark:text-gray-400">No carousel data available</p>
            </div>
        );
    }

    return (
        <Carousel carousel={carousel} dictionary={dictionary} lang={lang} />
    );
};

export default Hero;